export default __webpack_public_path__ + "static/media/twitter.73833931.png";